import router from '@/router';

export default {
	state:
		{
			userMsg: {},
		},
	getters: {},
	mutations:
		{
			setUserMsg (state: any, list: Object) {
        		state.userMsg = list;
			},
		},
	actions:
		{
			async getUserMsg ({ commit }: any, params: Array<any>) {
				const { error, success }: any = await router.app.$request('USER_MSG', params);
				success && commit('setUserMsg', success.data);
						return { error, success };
			},
     		async resetPassword ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('RESET_PASSWORD', params);
				return { error, success };
			},
			async logOut ({ commit }: any, params: any) {
				const { error, success }: any = await router.app.$request('LOG_OUT', params);
				return { error, success };
			},
    },

};
